import { motion } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const faqs = [
        {
            question: 'When will DareUp launch?',
            answer: "We're targeting Q1 2026. Waitlist members get first access! We'll email you as soon as we're ready to launch.",
        },
        {
            question: 'Is DareUp free?',
            answer: 'Yes! DareUp will be free to use. We may offer optional premium features later, but the core experience will always be free.',
        },
        {
            question: 'What platforms will DareUp be on?',
            answer: 'DareUp will be available on both iOS and Android. Download from the App Store and Google Play when we launch in Q1 2026.',
        },
        {
            question: 'Can I create my own dares?',
            answer: "At launch, you'll choose from our curated library of fun, safe dares. User-created dares are coming in Phase 2 after we validate product-market fit!",
        },
        {
            question: 'Is DareUp safe?',
            answer: 'Absolutely! Every dare is pre-reviewed by our team for safety. We have AI + human content moderation on all videos, age verification, and easy report/block tools.',
        },
        {
            question: 'What age do I need to be?',
            answer: "You need to be 13+ to use DareUp. If you're 13-17, we recommend letting your parents know (and they can check out our safety features).",
        },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">
                        Frequently Asked Questions
                    </h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">Got questions? We've got answers.</p>
                </motion.div>

                <div className="max-w-3xl mx-auto space-y-4">
                    {faqs.map((faq, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="bg-dark-800 border border-dark-700 rounded-2xl shadow-lg overflow-hidden"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-dark-700/50 transition-colors"
                            >
                                <span className="font-display text-lg font-bold text-white pr-4">{faq.question}</span>
                                <ChevronDown
                                    className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${
                                        openIndex === index ? 'rotate-180' : ''
                                    }`}
                                />
                            </button>

                            <div
                                className={`overflow-hidden transition-all duration-300 ${
                                    openIndex === index ? 'max-h-96' : 'max-h-0'
                                }`}
                            >
                                <div className="px-6 pb-5 text-gray-400 leading-relaxed">{faq.answer}</div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
